export const BUSINESS_CATEGORIES = [
    "Clothing", "Footwear", "Jewellery", "Restaurant", "Cafe", "Salon", "Spa",
    "Gym", "Electronics", "Mobile Shop", "Furniture", "Repair", "Automobile",
    "Bakery", "Education", "Beauty", "Grocery", "Hardware", "Photography",
    "Travel", "Real Estate", "Professional Service", "Other",
];

export const ACCENT_PRESETS = [
    { name: "Periwinkle", value: "#4f6cd6" },
    { name: "Teal", value: "#0ea5a3" },
    { name: "Saffron", value: "#e0792b" },
    { name: "Terracotta", value: "#b4472f" },
    { name: "Violet", value: "#7c5cd6" },
    { name: "Rose", value: "#c2185b" },
];

export function digits(n) {
    return (n || "").replace(/[^0-9]/g, "");
}

export function waLink(number, text) {
    const n = digits(number);
    const t = encodeURIComponent(text || "");
    if (!n) return "#";
    return `https://wa.me/${n}${t ? `?text=${t}` : ""}`;
}

export function telLink(number) {
    const n = (number || "").replace(/[^0-9+]/g, "");
    return n ? `tel:${n}` : "#";
}

export function mapsLink(biz) {
    if (biz?.maps_link) return biz.maps_link;
    const q = [biz?.address, biz?.area, biz?.city].filter(Boolean).join(", ");
    return q ? `https://maps.google.com/?q=${encodeURIComponent(q)}` : "#";
}
